import { baseAPI } from "../../../baseApi";
import { tagsTypes } from "../../../tagsTypes";

export const productScheduleAndPricingSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    // Save product price option
    postProductPriceOptions: builder.mutation({
      query: (data) => ({
        url: "product-price-options-save",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // Update product price option
    updateProductPriceSchedule: builder.mutation({
      query: (data) => ({
        url: `product-price-schedule-update/${data?.lang}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL,tagsTypes.GET_PRODUCT_LIST],
    }),

    // Update product price option
    updateProductPriceOptions: builder.mutation({
      query: ({data,lang}) => ({
        url: `product-price-options-update/${lang}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // Get weekly days
    getWeeklyDays: builder.query({
      query: () => ({
        url: "product-days-of-week",
        method: "GET",
      }),
    }),

    // Get age group data
    getAgeGroupData: builder.query({
      query: (productId) => ({
        url: `product-price-age-group?product_id=${productId}`,
        method: "GET",
      }),
    }),

    // Save product price schedule non exclusive
    postPriceScheduleNonExclusive: builder.mutation({
      query: (data) => ({
        url: "product-price-schedule-non-exclusive",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // Save product price schedule exclusive
    postPriceScheduleExclusive: builder.mutation({
      query: (data) => ({
        url: "product-price-schedule-exclusive",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // Delete schedule
    deleteSchedule: builder.mutation({
      query: (id) => ({
        url: `product-price-schedule-delete/${id}`,
        method: "POST",
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // Delete all schedule
    deleteAllSchedule: builder.mutation({
      query: (id) => ({
        url: `product-price-option-delete/${id}`,
        method: "POST",
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // post mark as a default price option
    postMarkAsDefault: builder.mutation({
      query: ({ id }) => ({
        url: `mark-as-default-option/${id}`,
        method: "POST",
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),
  }),
});

export const {
  usePostProductPriceOptionsMutation,
  useGetWeeklyDaysQuery,
  useGetAgeGroupDataQuery,
  usePostPriceScheduleNonExclusiveMutation,
  usePostPriceScheduleExclusiveMutation,
  useDeleteScheduleMutation,
  useUpdateProductPriceOptionsMutation,
  useUpdateProductPriceScheduleMutation,
  useDeleteAllScheduleMutation,
  usePostMarkAsDefaultMutation,
} = productScheduleAndPricingSlice;
